export default __webpack_public_path__ + "static/6-d7b7fa75f67f8529a264609c97aa5497.woff";